module.exports = __webpack_public_path__ + "static/media/cf9e7886.jpg";